import { getResidence } from './residences';

const saleCatalog = [
  {
    apartmentNumber: '32',
    residenceId: 'residence-03',
    floor: { en: '2nd floor', ru: '2 этаж' },
    price: { en: '€495,000', ru: '495 000 €' },
    lead: {
      en: 'A substantial three-bedroom apartment with a broad terrace, a generous open living area and views towards the Adriatic coast.',
      ru: 'Просторный апартамент с тремя спальнями, большой террасой, открытой общей зоной и видом в сторону Адриатического побережья.',
    },
    heroLine: {
      en: 'Generous proportions and an open outlook towards the Adriatic',
      ru: 'Просторные интерьеры и открытая перспектива в сторону Адриатики',
    },
    storyTitle: {
      en: 'Room for family life, guests and unhurried days by the sea',
      ru: 'Пространство для семьи, гостей и неспешной жизни у моря',
    },
    story: {
      en: [
        'Grand 3BD brings three well-proportioned bedrooms together with an expansive open living and dining area. The broad terrace draws the home towards the Adriatic and gives the main living space a natural outdoor extension.',
        'The apartment is ready for comfortable everyday living, with an equipped kitchen, a full bathroom and an additional guest toilet. A private parking space and storage room are included in the price.',
      ],
      ru: [
        'Grand 3BD объединяет три полноценные спальни с большой открытой гостиной и обеденной зоной. Широкая терраса обращает пространство к Адриатике и становится естественным продолжением интерьера.',
        'Апартамент готов для комфортной повседневной жизни: оборудованная кухня, полноценный санузел и дополнительный гостевой туалет. Приватное парковочное место и кладовая включены в стоимость.',
      ],
    },
    highlights: {
      en: [
        'Three well-proportioned bedrooms',
        'Broad private terrace',
        'Generous living and dining area',
        'Full bathroom and additional guest toilet',
        'Private storage room included in the price',
        'Private parking space included in the price',
      ],
      ru: [
        'Три полноценные спальни',
        'Большая приватная терраса',
        'Просторная гостиная и обеденная зона',
        'Полный санузел и дополнительный гостевой туалет',
        'Приватная кладовая включена в стоимость',
        'Парковочное место включено в стоимость',
      ],
    },
    highlightIcons: ['bedrooms', 'terrace', 'living', 'bathrooms', 'storage', 'parking'],
    floorPlanImage: '/images/apartments/grand-3bd/stan_32.jpg',
  },
];

export const saleListings = saleCatalog.map((listing) => ({
  ...listing,
  residence: getResidence(listing.residenceId),
}));

export function getSaleListing(apartmentNumber) {
  return saleListings.find((listing) => listing.apartmentNumber === apartmentNumber);
}
